import { execAdmin } from '@src/apis/reware/utils';

import type { ConditionOption, FetchConditionsExecVariables, FetchConditionsExecResponse } from './types';

export interface FetchConditionsArgs {
  partnerId: number;
}

/**
 * Fetches condition options for a partner using the partner constants query.
 * Returns an array of ConditionOption objects with id, code, and label.
 */
export const fetchConditions = async ({ partnerId }: FetchConditionsArgs): Promise<ConditionOption[]> => {
  const query = `
    query getConditions($partnerId: Int!) {
      partner(id: $partnerId) {
        constants {
          inventoryItem {
            conditions {
              code
              displayName
            }
          }
        }
      }
    }
  `;

  const data = await execAdmin<FetchConditionsExecVariables, FetchConditionsExecResponse>(
    query,
    { variables: { partnerId } }
  );

  const conditions = data.partner?.constants?.inventoryItem?.conditions;
  if (!conditions) {
    throw new Error(
      `fetchConditions: unexpected response — partner.constants.inventoryItem.conditions is ${conditions === null ? 'null' : 'undefined'} (partnerId=${partnerId})`
    );
  }

  return conditions
    .filter((c): c is { code: string; displayName: string } =>
      c != null && c.code != null && c.displayName != null
    )
    .map(c => ({
      id: c.code,
      code: c.code,
      label: c.displayName,
    }));
};
